import {
  DOWNLOAD_INVENTORY_UNIT_QR_CODES,
  DOWNLOAD_INVENTORY_UNIT_QR_CODES_ADMIN,
  SYNC_INVENTORY_UNIT_QR_CODES,
  SYNC_INVENTORY_UNIT_QR_CODES_ADMIN,
} from './graphql/Mutations';
import {
  INVENTORY_UNITS,
  INVENTORY_UNITS_ADMIN,
  INVENTORY_UNIT_LOGS,
  INVENTORY_UNIT_LOGS_ADMIN,
} from './graphql/Queries';

const INVENTORY_UNIT_APIS = {
  ADMIN: {
    units: { document: INVENTORY_UNITS_ADMIN, key: 'inventoryUnitsAdmin' },
    logs: { document: INVENTORY_UNIT_LOGS_ADMIN, key: 'inventoryUnitLogsAdmin' },
    sync: {
      document: SYNC_INVENTORY_UNIT_QR_CODES_ADMIN,
      key: 'syncInventoryUnitQrCodesAdmin',
      getVariables: ({ libraryId, libraryInventoryIds }) => ({
        where: { id: libraryId },
        data: { libraryInventoryIds },
      }),
    },
    download: {
      document: DOWNLOAD_INVENTORY_UNIT_QR_CODES_ADMIN,
      key: 'downloadInventoryUnitQrCodesAdmin',
      getVariables: ({ libraryId, libraryInventoryIds, unitIds }) => ({
        data: {
          libraryId,
          ...(libraryInventoryIds && { libraryInventoryIds }),
          ...(unitIds && { unitIds }),
        },
      }),
    },
  },
  LIBRARIAN: {
    units: { document: INVENTORY_UNITS, key: 'inventoryUnits' },
    logs: { document: INVENTORY_UNIT_LOGS, key: 'inventoryUnitLogs' },
    sync: {
      document: SYNC_INVENTORY_UNIT_QR_CODES,
      key: 'syncInventoryUnitQrCodes',
      getVariables: ({ libraryInventoryIds }) => ({
        data: { libraryInventoryIds },
      }),
    },
    download: {
      document: DOWNLOAD_INVENTORY_UNIT_QR_CODES,
      key: 'downloadInventoryUnitQrCodes',
      getVariables: ({ libraryInventoryIds, unitIds }) => ({
        data: {
          ...(libraryInventoryIds && { libraryInventoryIds }),
          ...(unitIds && { unitIds }),
        },
      }),
    },
  },
};

export const getInventoryUnitApis = (isLibrary) =>
  isLibrary ? INVENTORY_UNIT_APIS?.LIBRARIAN : INVENTORY_UNIT_APIS?.ADMIN;

export const withLibraryScope = (isLibrary, libraryId) =>
  isLibrary ? {} : { libraryId };

export const hasLibraryScope = (isLibrary, libraryId) =>
  isLibrary || Boolean(libraryId);
